import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Members from './components/Members';
import Payments from './components/Payments';
import Leads from './components/Leads';
import FollowUp from './components/FollowUp';
import Expenses from './components/Expenses';
import Insights from './components/Insights';
import Attendance from './components/Attendance';
import Invoice from './components/Invoice';
import AddStaff from './components/AddStaff';
import AdminSettings from './components/AdminSettings';
import Support from './components/Support';
import Layout from './components/Layout';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  return user ? children : <Navigate to="/login" />;
};

// Admin-only route protection
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  if (user.role !== 'admin') return <Navigate to="/" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="members" element={<Members />} />
            <Route path="payments" element={<Payments />} />
            <Route path="leads" element={<Leads />} />
            <Route path="followup" element={<FollowUp />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="insights" element={<Navigate to="/insights/members" replace />} />
            <Route path="insights/:section" element={<Insights />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="invoice" element={<Invoice />} />
            <Route path="staff" element={<AdminRoute><AddStaff /></AdminRoute>} />
            <Route path="settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
            <Route path="support" element={<Support />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
